// @ts-nocheck
import React, { useState } from 'react';
import { mergeOverrides } from 'baseui';
import { Overrides } from 'baseui/overrides';
import { useStyletron } from '../../Themes';
import { overrides as customOverrides } from './overrides';
import { Dropdown } from '../Dropdown';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
import { MIcon } from '../Icon';
import { Link } from '../Link';
import { DossierOption, IDummyProps } from './types';
import {
	blueContainer,
	subtitleContainer,
	modalWrapper,
	modalContainer,
	boldText,
	modalHeaderText,
	externalLinkCenter,
	externalLinkLeft,
	firstUsageExamples,
	customButtonStyle,
} from './styles';

import {
	DOSSIER_ITEMS_LOCAL_STORAGE_KEY,
	EXAMPLE_OF_DOSSIER_FORMATS_MESSAGE,
	NO_RESULTS_FROUND_MESSAGE,
	NUMBER_OF_RECENT_DOSSIERS_DISPLAYED,
} from './constants';

import { Checkbox } from '../Checkbox';

// TODO: GENERAL REFACTOR :: MOVE LOGIC TO index.tsx

const NoResultsModalContent = ({ value = '', externalLinkLabel = 'Go to Ansera', externalLink }: any) => {
	const [css] = useStyletron();

	return (
		<>
			<div className={css(modalHeaderText())}>{NO_RESULTS_FROUND_MESSAGE}</div>
			<div className={css(blueContainer())}>
				<div className={css(subtitleContainer())}>
					<MIcon size="48px" icon="search" color={'var(--epods--color-text-primary-action)'} />
					<div className={css(boldText())}>{`Do you want to do a search for "${value}"?`}</div>
				</div>

				{externalLink && (
					<div className={css(externalLinkCenter())}>
						<Link tabIndex={0} aria-label="Link to nowhere" href={externalLink} iconAfter={'open_in_new'}>
							{externalLinkLabel}
						</Link>
					</div>
				)}
			</div>
		</>
	);
};

const FirstUsageModalContent = ({
	learnMoreLink,
	learnMoreLinkLabel = 'Learn more',
	displayCheckboxValue,
	onChangeDisplayCheckbox,
}: any) => {
	const [css] = useStyletron();

	return (
		<>
			<div className={css(blueContainer())}>
				<div className={css(subtitleContainer())}>
					<MIcon size="48px" icon="search" color={'var(--epods--color-text-primary-action)'} />
					<div className={css(boldText())}>{EXAMPLE_OF_DOSSIER_FORMATS_MESSAGE}</div>
				</div>

				<div className={css(firstUsageExamples())}>
					12345678 (minimum 8 digits)
					<br />
					EP12345678
					<br />
					EP12345678.9
				</div>
				{learnMoreLink && (
					<div className={css(externalLinkLeft())}>
						<Link tabIndex={0} aria-label="Link to nowhere" href={learnMoreLink}>
							{learnMoreLinkLabel}
						</Link>
					</div>
				)}
				{onChangeDisplayCheckbox && (
					<Checkbox checked={displayCheckboxValue} onChange={onChangeDisplayCheckbox}>
						Don't display again
					</Checkbox>
				)}
			</div>
		</>
	);
};

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const {
		searchResult = [],
		recentOpenedDossiers,
		disabled,
		onSearchTrigger,
		onSelectDossier,
		initialValue,
		firstUsage,
		positive,
		error,
		readOnly,
		externalLink,
		externalLinkLabel,
		learnMoreLink,
		learnMoreLinkLabel,
		displayCheckboxValue,
		onChangeDisplayCheckbox,
		overrides,
		noResultMsg,
		customButton,
		...rest
	} = props;

	const [isExpanded, setIsExpanded] = useState<boolean>(false);
	const [css] = useStyletron();
	const localStorageDossiersString = localStorage.getItem(DOSSIER_ITEMS_LOCAL_STORAGE_KEY);
	const localStorageDossiers =
		localStorageDossiersString && (JSON.parse(localStorageDossiersString) as DossierOption[]);

	const [inputValue, setInputValue] = useState<any>();
	const [value, setValue] = useState<any>(initialValue ? [initialValue] : []);
	const [recentDossiers, setRecentDossiers] = useState<DossierOption[]>(
		recentOpenedDossiers || localStorageDossiers || [],
	);

	const updateRecentDossiers = (selectedDossier: DossierOption) => {
		// selectedDossier is null onClear
		if (selectedDossier) {
			if (recentDossiers?.find(dossier => dossier?.id === selectedDossier?.id)) return;

			const newDossiers =
				recentDossiers?.length === 3
					? [...recentDossiers?.slice(1, NUMBER_OF_RECENT_DOSSIERS_DISPLAYED), selectedDossier]
					: [...recentDossiers, selectedDossier];

			setRecentDossiers(newDossiers);

			localStorage.setItem(DOSSIER_ITEMS_LOCAL_STORAGE_KEY, JSON.stringify(newDossiers));
		}
	};

	const handleSelectDossier = (selectedDossier: DossierOption) => {
		!recentOpenedDossiers && updateRecentDossiers(selectedDossier);
		onSelectDossier && onSelectDossier(selectedDossier);
	};

	const getLabel = ({ option }: DossierOption) => option.label;

	const options = firstUsage
		? []
		: {
				Recent: recentDossiers,
				Search: searchResult,
		  };

	const localOverrides = customOverrides(props, isExpanded, css) as any;

	return (
		<div className={css(modalContainer())} data-epo="epo-dossier-input" ref={ref}>
			<Dropdown
				clearable
				backspaceRemoves
				aria-label="Search dossier"
				value={value}
				options={options as any}
				placeholder="EP12345678"
				getOptionLabel={getLabel}
				onChange={
					((param: any) => {
						setValue(param.value);
						handleSelectDossier(param.option);
					}) as any
				}
				onOpen={() => setIsExpanded(true)}
				onClose={() => setIsExpanded(false)}
				onInputChange={(event: any) => {
					setInputValue((event?.target as HTMLInputElement)?.value);
					onSearchTrigger && onSearchTrigger(event?.target?.value);
				}}
				overrides={overrides ? mergeOverrides(localOverrides, overrides as Overrides<any>) : localOverrides}
				error={error}
				disabled={disabled}
				positive={positive}
				readOnly={readOnly}
				noResultsMsg={
					noResultMsg ||
					(firstUsage ? (
						<FirstUsageModalContent
							learnMoreLink={learnMoreLink}
							learnMoreLinkLabel={learnMoreLinkLabel}
							displayCheckboxValue={displayCheckboxValue}
							onChangeDisplayCheckbox={onChangeDisplayCheckbox}
						/>
					) : (
						<NoResultsModalContent
							value={inputValue}
							externalLinkLabel={externalLinkLabel}
							externalLink={externalLink}
						/>
					))
				}
				{...rest}
			/>
			{customButton && !error && !readOnly &&
				<Tooltip content="Open dossier">
					<Button type="submit" iconBefore="epo_dossier_outline" theme="tertiary" className={css(customButtonStyle())} aria-label="open dossier input" />
				</Tooltip>
			}
		</div>
	);
});
